import { Button, Container, Group, Stack, Text, Title } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import classes from './no-permission.module.css'

interface ErrorPageProps {
  error?: Error
  inShell?: boolean
}

export default function ErrorPage({ error, inShell = false }: ErrorPageProps) {
  const content = (
    <Stack justify="center" h={inShell ? '70vh' : undefined}>
      <div className={classes.label}>เกิดข้อผิดพลาด</div>
      <Title className={classes.title}>ขออภัย มีบางอย่างผิดปกติ</Title>
      <Text c="dimmed" size="lg" className={classes.description}>
        เกิดข้อผิดพลาดในระบบ กรุณาลองใหม่อีกครั้ง
        {error?.message && (
          <>
            <br />
            <br />
            รายละเอียด: {error.message}
          </>
        )}
      </Text>
      <Group justify="center" gap="md">
        <Button onClick={() => window.location.reload()} size="md">
          ลองใหม่
        </Button>
        <Link to="/home">
          <Button variant="subtle" size="md">
            กลับสู่หน้าหลัก
          </Button>
        </Link>
      </Group>
    </Stack>
  )

  if (inShell) {
    return (
      <Container fluid p="md">
        {content}
      </Container>
    )
  }

  return <Container className={classes.root}>{content}</Container>
}
